table{width:100%}
/*# sourceMappingURL=details.component-NQRC4SXE.css.map */
